import styled from 'styled-components'
import { DEVICES } from 'theme/devicesSizes'

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden; 
  
  @media ${DEVICES.laptop} {
    overflow-x: hidden; 
    overflow-y: auto;
  }
`

export const ViewBoxBalanceContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
  padding: 0 40px; 
  margin-top: 20px;
  gap: 20px;
  width: 100%;
  box-sizing: border-box;

  @media ${DEVICES.mobile} {
    flex-direction: column;
    align-items: center; 
    padding: 0 16px;
    gap: 24px;
  }
`

export const ViewBoxContainer = styled.div`
  flex: 1.5;
  width: 100%;
  min-width: 300px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: auto;

  @media ${DEVICES.mobile} {
    flex: none;
    margin: 0 auto;
    width: 80%;
    align-self: start;
  }
`

export const ActionCardsWrapper = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  width: 100%;
  max-width: 450px;

  @media ${DEVICES.mobile} {
    flex: none;
    width: fit-content;
    margin: 0 auto; 
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px; 
  }
`

export const TableSectionWrapper = styled.div`
  padding: 0 0 0 10px;
  margin-top: 40px;
  flex: 1;
  overflow-y: auto;
  min-height: 0;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 10px;
  }

  @media ${DEVICES.mobile} {
    padding: 0 16px;
    width: 100%;
    box-sizing: border-box;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    display: block; 
  }
`
